import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useCancelSubscription, useModals } from 'hooks';

import { normalizeDateByLocale } from 'pages/AccountSettings/components/SubscriptionsTab/components/SubscriptionCard/helpers';

import SolidPaymentForm from 'components/SolidPaymentForm';
import OutlinedButton from 'components/OutlinedButton';
import Modal from 'components/Modal/Modal';
import { Box, Text } from 'components/library';
import { selectCountry } from 'store/user/selectors';

const BoldText = ({ content }: { content: string }) => {
  return (
    <Text inline medium type="large-text" bold>
      {content}
    </Text>
  );
};

const CancellationFeePaymentModalContainer = () => {
  const { closeModal } = useModals();
  const { t } = useTranslation();

  const country = useSelector(selectCountry);

  const { cancellationCandidate } = useCancelSubscription();
  const expirationDate = normalizeDateByLocale(cancellationCandidate!.expired_date, country);

  const feeData = useMemo(() => {
    return { amount: `${cancellationCandidate?.fee.fee_price} ${cancellationCandidate?.product.currency}` };
  }, [cancellationCandidate]);

  return (
    <Modal isOpen withCloseButton onClose={closeModal}>
      <Box $paddingTop={60} $paddingBottom={20} $paddingX={16}>
        <Text type="h5" bold center mb={24}>
          {t('subscription.cancelFlow.commitment.payAndCancelText')}
        </Text>
        <Text center mb={24}>
          <Trans
            i18nKey="subscription.cancelFlow.commitment.payFeeModal.subtitle.new"
            components={{
              1: <BoldText content={feeData.amount} />,
              2: <BoldText content={expirationDate} />,
            }}
          />
        </Text>
        <SolidPaymentForm />
        <OutlinedButton onClick={closeModal}>{t('subscription.text.keep')}</OutlinedButton>
      </Box>
    </Modal>
  );
};

export default CancellationFeePaymentModalContainer;
